import { LitElement, html } from "lit"
import { customElement, property } from "lit/decorators.js"

import componentStyle from "../common/styles/Component.css"
import style from "./Badge.css"

/**
 * Badges are used to inform users of the status of an object
 * or of an action that’s been taken. Commonly used in tabular
 * data to indicate status.
 *
 * @status ready
 * @category text
 * @slot - The badge content.
 * @slot icon - Used to place an icon at the start of badge.
 */
@customElement("nord-badge")
export default class Badge extends LitElement {
  static styles = [componentStyle, style]

  /**
   * The type of badge.
   * Determines the background color of the badge.
   * @deprecated Use `variant` instead. If you previously used `"progress"`, use `"info"` instead.
   * @default "neutral"
   */
  @property({ reflect: true }) type?: "warning" | "success" | "danger" | "highlight" | "info" | "neutral" | "progress"

  /**
   * The style variant of the badge.
   * Determines the background color of the badge.
   * @default "neutral"
   */
  @property({ reflect: true }) variant?: "warning" | "success" | "danger" | "highlight" | "neutral" | "info"

  /**
   * Strong badges are a secondary style for badges.
   * They provide more visual prominence and emphasize them.
   */
  @property({ reflect: true, type: Boolean }) strong = false

  render() {
    return html`
      <span class="n-badge">
        <slot name="icon"></slot>
        <slot></slot>
      </span>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "nord-badge": Badge
  }
}
